export default "__VITE_ASSET__ClIMIORs__"